<template>
  <div id="lm-wait">

<b-form-group
      id="imagen"
      label-cols-sm="2"
      label-cols-lg="2"
      label="Imagen"
      label-for="input-horizontal"
      class="align-items-center"
    >

      <LmUploadFiles
            label=""
            ref="lmUploadFiles"
            class="mb-2"
            :dropzoneOptions="dropzoneOptions"
            dictDefaultMessage='Arrastre la imagen acá para subirla'
            @vdropzone-removed-file="fileRemoved"
            @vdropzone-success="fileCreated"
        />

        </b-form-group>

<b-form-group
      id="urlAppStore"
      label-cols-sm="2"
      label-cols-lg="2"
      label="URL AppStore"
      label-for="input-horizontal"
      class="align-items-center"
    >

    <b-form-input
        class="mb-0"
        list="my-list-id"
        v-model="options.urlAppStore"
        @keydown="$parent.$parent.$parent.$parent.disambleBtnGuardar = true"
        />

    </b-form-group>

<b-form-group
      id="link"
      label-cols-sm="2"
      label-cols-lg="2"
      label="URL PlayStore"
      label-for="input-horizontal"
      class="align-items-center"
    >

        <b-form-input
        class="mb-0"
        list="my-list-id"
        v-model="options.urlPlayStore"
        @keydown="$parent.$parent.$parent.$parent.disambleBtnGuardar = true"
        />

     </b-form-group>

<b-form-group
      id="link"
      label-cols-sm="2"
      label-cols-lg="2"
      label="Título"
      label-for="input-horizontal"
      class="align-items-center"
    >

      <LmEditor
              class="mb-0"
              @onUpdate="options.title = $event"
              label="Título"
              list="my-list-id"
              :contentProps="options.title"
              :activeTable="false"
              :activeUnderline="false"
              :activeItalic="false"
              :activeParagraph="false"
              :activeStrike="false"
              :activeLink="false"
              :activeH3="false"
              :activeH4="false"
              :activeH5="false"
              :activeH6="false"
              :activeBulletList="false"
              :activeOrderedList="false"
              :activeBlockquote="false"
              :activeHR="false"
              @click.native="$parent.$parent.$parent.$parent.disambleBtnGuardar = true"
          />

    </b-form-group>

    <b-form-group
      id="link"
      label-cols-sm="2"
      label-cols-lg="2"
      label="Título Color"
      label-for="input-horizontal"
      class="align-items-center"
    >

    <swatches
      v-model="options.titleColor"
      :swatches="swatches"
      :trigger-style="{ width: '26px', height: '26px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
      :swatch-style="{ width: '41px', height: '41px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
      show-fallback
      popover-to="left"
      @click.native="$parent.$parent.$parent.$parent.disambleBtnGuardar = true"
    ></swatches>

    </b-form-group>

<b-form-group
      id="link"
      label-cols-sm="2"
      label-cols-lg="2"
      label="Fondo"
      label-for="input-horizontal"
      class="align-items-center"
    >

    <swatches
      v-model="options.background"
      :swatches="swatches"
      :trigger-style="{ width: '26px', height: '26px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
      :swatch-style="{ width: '41px', height: '41px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
      show-fallback
      popover-to="left"
      @click.native="$parent.$parent.$parent.$parent.disambleBtnGuardar = true"
    ></swatches>

    </b-form-group>

  </div>
</template>

<script>
import store from '@/store'

import LmSelect from '@/components/form/elements/LmSelect'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmUploadFiles from '@/components/LmUploadFiles'
import LmEditor from '@/components/form/elements/lmEditor'

import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'

export default {
  components: {
    LmSelect,
    LmTextInput,
    LmUploadFiles,
    Swatches,
    LmEditor
  },
  data () {
    return {
      files: [],
      swatches: ['#fff3ce', '#f03d37', '#000000', '#ffffff'],
      background: '',
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${store.state.session.accessToken}`
        },
        withCredentials: true,
        thumbnailWidth: 150,
        maxFiles: 1,
        addRemoveLinks: true,
        acceptedFiles: 'image/*'
      }
    }
  },
  props: {
    form: {
      dataList: ''
    },
    apiUrlPath: '',
    dataValue: '',
    options: {
      type: Object,
      id: '',
      title: '',
      default: () => ({
        disabledOption: 'Seleccione una acción',
        content: []
      })
    }
  },
  methods: {

    setForm () {
      if (this.options.image) {
        const fileOption = {
          size: 100000
        }

        let urlImage = this.apiUrlPath + this.options.image
        this.$refs.lmUploadFiles.lmManuallyAddFile(fileOption, urlImage)
      }
    },
    fileCreated (file, response) {
      if (response) {
        this.options.image = response.path
        this.files.push(response)
      }
      this.$refs.lmUploadFiles.disable()
    },
    fileRemoved (file, error, xhr) {
      this.files = []
      this.$emit('fileRemovedImage', this.index)
      if (file) {
        this.files = this.files.filter(f => f.originalname !== file.name)
      }
      this.$refs.lmUploadFiles.enable()
    }
  },
  mounted () {
    this.setForm()
  }
}
</script>
